export default "__VITE_ASSET__2e0261bf__"